<template>
    <v-container style="margin-top:10px">
        <v-layout>
            <v-flex xs12 sm12 md8 lg8 xl8 style="margin:auto">
                <v-card >
                    <v-card-title style="font-weight: bold">
                        MỤC ĐÃ LƯU
                    </v-card-title>
                    <v-card-text>
                        <div v-if="posts.length>0">
                            <post :item="item" v-for="item in posts" :key="item.postId" :editable="false" :saved="true" @reload="getPost"/>
                            <div v-if="posts.length == postCount"
                                 style="font-weight: bold;text-align: center;padding-top: 10px">
                                Không có thêm bài viết nào
                            </div>
                        </div>
                        <div v-else style="text-align: center">
                            <div style="font-weight: bold">Bạn hiện chưa lưu bài nào</div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {message} from '../../services';
    import axios from "axios";
    import ClazzCreate from "../class/createClass";
    import TeacherInfo from "../class/teacherProfile";
    import Post from "./post";

    export default {
        components: {Post, TeacherInfo, ClazzCreate},
        props: {
            objectType: {
                type: String | Number,
                default: 0
            },
            classId: {
                type: String | Number,
                default: null
            },

        },

        computed: {
            styleOfFeed: function () {
                if (this.editting) {
                    return "feed active";
                } else {
                    return "feed";
                }
            },

            backgroundStyle: function () {
                if (this.editting) {
                    return "background show";
                } else {
                    return "background";
                }
            }
        },

        watch: {
            classId: function (data) {
                this.getPost();
            }
        },

        data() {
            return {
                postCount: 0,
                posts: [],
                page: 1,
                pageSize: 10
            }
        },

        created() {
            this.getPost();
        },
        methods: {
            loadMore: function () {
                let page = Math.floor(this.posts.length / this.pageSize) + 1;
                axios.post(process.env.VUE_APP_API_URL + "/post/onSearchSavedPost?page=" + page + "&pageSize=" + this.pageSize).then(
                    data => {
                        this.postCount = data.count;
                        for (let i = 0; i < data.items.length; i++) {
                            let bDuplicate = false;
                            for (let j = this.posts.length - 1; j >= 0; j--) {
                                if (data.items[i].postId == this.posts[j].postId) {
                                    bDuplicate = true;
                                    break;
                                }
                            }
                            if (!bDuplicate) {
                                this.posts.push(data.items[i]);
                            }
                        }
                    },
                    error => {

                    }
                )
            },

            getPost: function () {
                axios.post(process.env.VUE_APP_API_URL + "/post/onSearchSavedPost?page=" + this.page + "&pageSize=" + this.pageSize).then(
                    data => {
                        this.postCount = data.count;
                        this.posts = data.items;
                        console.log(this.posts);
                    },
                    error => {

                    }
                )
            }
        }
    };
</script>